/*================ Eligible Vehicles Factory
  ========================================*/
  angular
    .module('vppApp')
    .factory('VehicleLinksFactory', VehicleLinksFactory);

    EligibleVehiclesFactory.$inject = ['$http', '$rootScope'];

    function VehicleLinksFactory($http, $rootScope){
      
      var eligibleVehiclesLinks = {

       getVehicleLinks : function(){
          var Url  ="../content/common/vehicle-links.json";
          var promise = $http.get(Url).then(function(response){
            return response.data;
          });
          return promise;
        }
      };
      return eligibleVehiclesLinks;
  };
